import React from 'react'
import TeachersTop from "./teachers-components/teachersTop"
import TeachersIntro from "./teachers-components/teachersIntro"

const Teachers = () => {

   return (
      <>
         <TeachersTop />
         <TeachersIntro />
      </>
   )
}


export default Teachers